export enum Interaction {
    mouseenter = 'mouseenter',
    mouseleave = 'mouseleave',
    mousedown = 'mousedown',
    mouseup = 'mouseup',
    touchend = 'touchend',
    touchstart = 'touchstart',
    touchmove = 'touchmove',
    touchcancel = 'touchcancel',
    touch = 'touch',
    click = 'click',
}
